import { useState } from 'react'
import Button from '@talkdesk/cobalt-react-button'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import Input from '@talkdesk/cobalt-react-input'
import InputGroup, { Item } from '@talkdesk/cobalt-react-input-group'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'

const PasswordInputFieldGroup = ({
  label,
  disabledForm = false,
  placeholder,
  password,
  onPasswordChange,
  autoFocus = false,
  onFocus,
  onBlur,
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const handleShowPassword = () => setShowPassword((prev) => !prev)

  return (
    <Box>
      <Box paddingY='2'>
        <Label>{label}</Label>
      </Box>
      <InputGroup size='medium' disabled={disabledForm}>
        <Item>
          <Flex width='100%' height='100%' alignY='center'>
            <Input
              size='medium'
              value={password}
              onChange={onPasswordChange}
              type={showPassword ? 'text' : 'password'}
              variation='unstyled'
              placeholder={placeholder}
              onFocus={onFocus}
              onBlur={onBlur}
              autoFocus={autoFocus}
            />
            <Button
              htmlType='button'
              shape='compact'
              variation='transparent'
              size='tiny'
              onClick={handleShowPassword}
              tabIndex='-1'
            >
              <IconWithProvider
                name={showPassword ? 'visibility_off' : 'visibility'}
                size='tiny'
              />
            </Button>
          </Flex>
        </Item>
      </InputGroup>
    </Box>
  )
}

export default PasswordInputFieldGroup
